import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ErrorIcon from '@mui/icons-material/Error';

interface StatusCheckLabelProps {
    text: React.ReactNode;
    /**
     * 视觉状态：成功 或 失败
     * - 'success'：绿色、已勾选
     * - 'fail'：红色、未勾选
     */
    status?: 'success' | 'fail';
}

const StatusCheckLabel: React.FC<StatusCheckLabelProps> = ({
    text,
    status,
}) => {
    // 颜色
    const finalColor = status === 'fail' ? 'error' : 'success';

    return (
        <Box className='FCC' sx={{ color: `${finalColor}.main` }}>
            {status !== 'fail' ? (
                <CheckBoxIcon color="success" />
            ) : (
                <ErrorIcon color="error" />
            )}
            <Typography sx={{ ml: 2,mr:2 }}>{text}</Typography>
        </Box>
    );
};

export default StatusCheckLabel;
